// extracted by mini-css-extract-plugin
module.exports = {"main":"Notifications_main__1237y","box":"Notifications_box__2HtLa"};